import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * When set to true on a request context the global loader is not shown for that request.
 * Use it for background polling / silent refresh calls.
 */
export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

export function skipGlobalLoader(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(SKIP_GLOBAL_LOADER, true);
}
